import type { FunctionComponent, ReactNode } from 'react';

import { Link, newAsyncDataEnvelope } from '@dr.pogodin/react-utils';

import {
  P_ADMIN_CONTENT_MANAGEMENT,
  type VideoT,
  getId,
  useGlobalStateObject,
} from 'utils';

type PropsT = {
  children: ReactNode;
  video: VideoT;
};

/**
 * Wraps children components with the link to the given video's edit page.
 * As an optimization, it also sets given video to the "editedVideo" segment of
 * the global state, thus saving an async loading operation on the target page.
 */
const VideoPageLink: FunctionComponent<PropsT> = ({ children, video }) => {
  const gs = useGlobalStateObject();

  return (
    <Link
      onClick={() => {
        gs.set('editedVideo', newAsyncDataEnvelope(video, {
          numRefs: gs.get('editedVideo.numRefs'),
          timestamp: Date.now(),
        }));
      }}
      to={`${P_ADMIN_CONTENT_MANAGEMENT}/${getId(video)}`}
    >
      {children}
    </Link>
  );
};

export default VideoPageLink;
